import { isFeatureEnabled } from './alerts_access'

// the audience for the Event Response Manager. every ERM gate -- the router
// guard, the nav rail, the site map, the dashboard widget -- reads this list
// rather than spelling the roles out, so they cannot drift apart (they had
// already started to: the rail entry carried its own note about which admin
// tier it let through).
//
// this covers ERM *access*: the event log, the board, the dashboard, and
// working an event (create, comment, status). it deliberately does NOT cover
// the settings modal or the admin-only event fields (reopen, coaching assign),
// which stay on the fleet-admin tier via ops_desk.vue's canEditAdminFields and
// tenant_erm_admin_required server-side.
//
export const ERM_ACCESS_ROLES = ['admin', 'customer-admin', 'customer', 'manager']

// staff (real 'admin', or an effective admin viewing as a tenant) always reach
// ERM; everyone else needs an allowed role plus the tenant flag. read the flag
// through isFeatureEnabled so a tbn tenant storing the string 'false' can't
// slip past a gate while another one hides the link.
export function hasErmAccess(role, features, isStaff) {
  if (isStaff) return true
  if (!ERM_ACCESS_ROLES.includes(role)) return false
  return isFeatureEnabled((features || {}).ops_desk_enabled)
}

// the left nav specifically: same audience, but ops_desk_enabled governs for
// EVERYONE, staff included (ben, 2026-08-28). a rail section for a product the
// account has not bought reads as an offer, and support seeing it on every
// fleet is how it gets demoed into existence. mirrors the coaching section's
// own no-staff-bypass gate in nav/registry.js.
//
// this is the nav only. hasErmAccess still admits staff, so the router guard
// keeps letting support reach ERM by URL on any tenant -- the section is
// unadvertised, not unreachable.
export function hasErmNavAccess(role, features) {
  return hasErmAccess(role, features, false)
}

// FI-2217: the driver scorecard's kudos metric. kudos are counted from ERM and
// linked to drivers through the TBN roster, so they exist only on a TBN tenant
// with ops_desk_enabled. the flag alone decides it, with no staff bypass: support
// viewing a tenant should see that tenant's scorecard, not a column of dashes.
export function tenantScorecardHasKudos(user) {
  if (!user || !user.tenant) return false
  if (((user.types || {})[user.tenant]) === 'CM') return false
  return isFeatureEnabled(((user.features || {})[user.tenant] || {}).ops_desk_enabled)
}
